import { Product } from "@~/types/types.ts";
import { useState } from "react";
import styles from "@~/product-card-components/QuickView/QuickView.module.scss";
import { SecondaryButton as V31SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SecondaryButton as DeprecatedSecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { QuickViewModal } from "@~/product-card-components/__shared__/QuickViewModal/QuickViewModal.tsx";
import { useFeatureFlags } from "@~/flags/flags";

type Props = {
  product: Product;
  handleButtonClick?: () => void;
};

export function QuickViewButton({ product, handleButtonClick }: Props) {
  const [showQuickView, setShowQuickView] = useState(false);
  const { isJldsV31Enabled } = useFeatureFlags();

  const handleClick = () => {
    if (handleButtonClick) {
      handleButtonClick();
    }
    setShowQuickView(true);
  };

  return (
    <>
      {isJldsV31Enabled?.value ? (
        <V31SecondaryButton
          className={styles["quick-view-button"]}
          onClick={handleClick}
          labelText="Quick View"
        />
      ) : (
        <DeprecatedSecondaryButton
          className={styles["quick-view-button"]}
          onClick={handleClick}
        >
          Quick View
        </DeprecatedSecondaryButton>
      )}
      {showQuickView && (
        <QuickViewModal
          product={product}
          showModal={true}
          onClose={() => setShowQuickView(false)}
          originator={undefined}
        />
      )}
    </>
  );
}
